import React from 'react';
import { FaWhatsapp, FaClock, FaMapMarkerAlt } from 'react-icons/fa';

// Updated Hero with Version A copy
const Hero = () => {
  const whatsappNumber = '5511972918839';
  const whatsappMessage = 'Olá! Gostaria de agendar um serviço na Mecânica Box 50.';

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/assets/hero-bg.png')`,
          backgroundAttachment: 'scroll'
        }}
      ></div>
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/85 via-black/80 to-secondary-dark/85"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo */}
          <div className="mb-1 hero-logo">
            <img 
              src="/assets/logo.png" 
              alt="Mecânica Box 50" 
              className="w-64 sm:w-80 md:w-96 mx-auto"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{display: 'none'}} className="text-center">
              <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold mb-2">
                <span className="text-white">MECÂNICA</span>
              </h1>
              <h1 className="text-6xl sm:text-7xl md:text-8xl font-bold">
                <span className="text-white">BOX</span>
                <span className="text-primary ml-2">50</span>
              </h1>
              <p className="text-accent text-xl sm:text-2xl font-bold mt-2 uppercase tracking-wider">Serviços Automotivos</p>
            </div>
          </div>

          {/* Badge */}
          <div className="hero-badge inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-3">
            <span className="text-primary text-lg">⭐</span>
            <span className="text-white text-sm font-medium">4.9 no Google • 10 anos em Araçariguama</span>
          </div>

          {/* Main Headline */}
          <h2 className="hero-title text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-1 leading-tight text-shadow">
            Cansado de Oficina que
            <span className="block text-primary mt-1">Inventa Problema?</span>
          </h2>

          {/* Subheadline */}
          <p className="hero-sub text-lg sm:text-xl md:text-2xl text-gray-200 mb-2 max-w-2xl mx-auto">
            Diagnóstico transparente + Orçamento sem surpresas.<br />
            <span className="text-primary font-semibold">10 anos em Araçariguama</span> e mais de <span className="text-primary font-semibold">500 clientes que voltam</span>.
          </p>

          {/* Info Cards */}
          <div className="hero-cards grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3 max-w-2xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 flex items-center gap-3">
              <FaClock className="text-primary text-2xl flex-shrink-0" />
              <div className="text-left">
                <p className="text-white font-semibold">Horário de Atendimento</p>
                <p className="text-gray-300 text-sm">Seg-Sex: 8h-12h, 13h-18h | Sáb: 8h-13h</p>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 flex items-center gap-3">
              <FaMapMarkerAlt className="text-primary text-2xl flex-shrink-0" />
              <div className="text-left">
                <p className="text-white font-semibold">Localização</p>
                <p className="text-gray-300 text-sm">Araçariguama - SP</p>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="hero-cta flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={handleWhatsAppClick}
              className="group bg-primary hover:bg-primary-dark text-secondary-dark font-bold py-4 px-8 rounded-lg text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-2xl flex items-center gap-3 w-full sm:w-auto justify-center"
            >
              <FaWhatsapp className="text-2xl" />
              <span>Quero Meu Orçamento Grátis</span>
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
            <a
              href="#servicos"
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-bold py-4 px-8 rounded-lg text-lg transition-all duration-300 border-2 border-primary/50 hover:border-primary w-full sm:w-auto text-center"
            >
              Ver Serviços e Preços
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="hero-trust mt-4 mb-16 flex flex-wrap justify-center gap-4 text-white/80 text-sm">
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-accent" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
              </svg>
              <span>+500 Clientes Satisfeitos</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-accent" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Garantia em Todos os Serviços</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-accent" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
              </svg>
              <span>Atendimento Rápido</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-50">
        <a href="#servicos" className="text-white/60 hover:text-white transition-colors block">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </a>
      </div>
    </section>
  );
};

export default Hero;
